import React, { useEffect, useState } from 'react';
import { Button, Card, CardContent, TablePagination } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import MUIDataTable from 'mui-datatables';
import { Edit, PictureAsPdf } from '@material-ui/icons';
import CustomeSearch from '../../../components/CustomSearch';
import ActiveFilter from '../../../components/ActiveFilter';
import UploadPdfDialog from '../../../components/UploadPdfDialog';
import EditPdfDialog from '../../../components/EditPdfDialog';
import { fetchToolboxTalks, addToolboxTalk, editToolboxTalk } from '../../../redux/actions/safety';
import { openAuthenticatedPdf } from '../../../services/safety';

const List = () => {
  const [isUploadOpen, setIsUploadOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [selectedTalk, setSelectedTalk] = useState(null);
  const [filterState, setFilterState] = useState({ isActive: '' });

  const dispatch = useDispatch();
  const { toolboxTalks } = useSelector(({ safety }) => safety);

  const getFilterObj = (values) => ({
    isActive: values.isActive === '' ? undefined : values.isActive
  });

  useEffect(() => {
    dispatch(fetchToolboxTalks({ page: 1, pageSize: 100, ...getFilterObj(filterState) }));
  }, []);

  const columns = [
    { name: 'title', label: 'Title' },
    { name: 'originalName', label: 'File Name' },
    {
      name: 'isActive',
      label: 'Status',
      options: { customBodyRender: (value) => (value ? 'Active' : 'Inactive') }
    },
    {
      name: 'id',
      label: 'Actions',
      options: {
        customBodyRender: (value) => (
          <>
            <PictureAsPdf
              style={{ cursor: 'pointer' }}
              color="primary"
              onClick={() => openAuthenticatedPdf(`/safety/toolbox-talks/${value}/file`)}
            />
            <Edit
              style={{ cursor: 'pointer' }}
              color="primary"
              onClick={() => {
                setSelectedTalk(toolboxTalks?.data.find((t) => t.id === value));
                setIsEditOpen(true);
              }}
            />
          </>
        )
      }
    }
  ];

  return (
    <Card className="userlist">
      <ActiveFilter
        onFilter={(values) => {
          setFilterState(values);
          dispatch(fetchToolboxTalks({ page: 1, pageSize: 100, ...getFilterObj(values) }));
        }}
        initialFormState={filterState}
      />
      <CardContent>
        <div className="userlist__header">
          <Button color="primary" variant="contained" onClick={() => setIsUploadOpen(true)}>
            Upload Toolbox Talk
          </Button>
        </div>
        <MUIDataTable
          title="Toolbox Talks"
          data={toolboxTalks?.data || []}
          columns={columns}
          options={{
            filterType: 'textField',
            responsive: 'standard',
            selectableRows: 'none',
            pagination: false,
            elevation: 0,
            customSearchRender: (searchText, handleSearch, hideSearch) => (
              <CustomeSearch handleSearch={handleSearch} hideSearch={hideSearch} />
            ),
            customFooter: () => (
              <tbody>
                <tr>
                  <TablePagination
                    rowsPerPage={toolboxTalks?.pageSize || 100}
                    count={toolboxTalks?.count || 0}
                    page={toolboxTalks?.page ? toolboxTalks.page - 1 : 0}
                    onPageChange={(event, page) =>
                      dispatch(
                        fetchToolboxTalks({
                          page: page + 1,
                          pageSize: toolboxTalks?.pageSize || 100,
                          ...getFilterObj(filterState)
                        })
                      )
                    }
                    onRowsPerPageChange={(event) =>
                      dispatch(
                        fetchToolboxTalks({
                          page: 1,
                          pageSize: event.target.value,
                          ...getFilterObj(filterState)
                        })
                      )
                    }
                    rowsPerPageOptions={[10, 20, 40, 80, 100]}
                  />
                </tr>
              </tbody>
            ),
            print: false,
            viewColumns: false
          }}
        />
      </CardContent>

      {isUploadOpen && (
        <UploadPdfDialog
          open={isUploadOpen}
          title="Upload Toolbox Talk"
          onUpload={addToolboxTalk}
          handleClose={() => setIsUploadOpen(false)}
          handleOk={() => {
            setIsUploadOpen(false);
            dispatch(fetchToolboxTalks({ page: 1, pageSize: 100, ...getFilterObj(filterState) }));
          }}
        />
      )}
      {isEditOpen && selectedTalk && (
        <EditPdfDialog
          open={isEditOpen}
          item={selectedTalk}
          onUpdate={editToolboxTalk}
          handleClose={() => {
            setIsEditOpen(false);
            setSelectedTalk(null);
          }}
          handleOk={() => {
            setIsEditOpen(false);
            setSelectedTalk(null);
          }}
        />
      )}
    </Card>
  );
};

export default List;
